import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Sidebar from "../../../../partials/aside/Sidebar";
import httpService from "../../../../../services/httpServices/httpServices";
import helpersNumber from "../../../../../helpers/numbers";
import helperSpinner from "../../../../../helpers/spinner";
import helpersTime from "../../../../../helpers/time";
import Pagination from "../../../../partials/content/Pagination";
import MobileHelper from "../../../../../helpers/mobile";

export default function AllMarketer() {
  const [users, setUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [countPage, setCountPage] = useState(1);
  const [userIdentityMarketer, setUserIdentityMarketer] = useState();
  const [userIDSearchFilter, setUserIDSearchFilter] = useState();

  useEffect(() => {
    getMarketers();
  }, []);

  useEffect(() => {
    getMarketers();
  }, [currentPage, countItemPerPage, userIDSearchFilter, userIdentityMarketer]);

  const getMarketers = async () => {
    const searchFilterQuery = getSearchFilterQuery();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const users = await sendRequestGetUser(searchFilterQuery);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!users) {
      return;
    }
    setUsers(users.marketer_user);
    setCountPage(users.count_page);
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const sendRequestGetUser = async (searchFilterQuery) => {
    const headersRequest = getHeaderForRequest();
    let users;
    try {
      users = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/marketer/manage?page=${currentPage}&number=${countItemPerPage}${searchFilterQuery}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return users.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const getSearchFilterQuery = () => {
    let searchFilterQuery = "";

    if (userIDSearchFilter) {
      searchFilterQuery = `${searchFilterQuery}&mar_user_id=${userIDSearchFilter}`;
    }

    if (userIdentityMarketer) {
      searchFilterQuery = `${searchFilterQuery}&mar_identity_marketer=${userIdentityMarketer}`;
    }

    return searchFilterQuery;
  };

  const generateUsers = () => {
    if (users.length == 0) {
      return <></>;
    }

    return users.map((user, index) => {
      return (
        <tr key={index}>
          <td>{helpersNumber.toPersianNum(index + 1)}</td>
          <td>{helpersNumber.toPersianNum(user.mar_user_id)}</td>
          <td>{user.first_name}</td>
          <td>{user.last_name}</td>
          <td dir="ltr">
            {helpersNumber.toPersianNum(MobileHelper.formatMobile(user.mobile))}
          </td>
          <td>{user.mar_identity_marketer}</td>
          <td>
            {user.mar_active ? (
              <span class="badge badge-success">فعال</span>
            ) : (
              <span class="badge badge-danger">غیرفعال</span>
            )}
          </td>
          <td>
            {helpersNumber.toPersianNum(
              helpersTime.convertGregorianToJalali(user.mar_created_at) +
                " " +
                user.mar_created_at.split(" ")[1]
            )}
          </td>
          <td>
            <span className="pr-2">
              <Link
                to={`/user/marketer/view/${user.mar_user_id}`}
                className="btn btn-info"
              >
                <i className="fa fa-info"></i>
              </Link>
            </span>
            <span className="pr-2">
              <Link
                to={`/user/marketer/edit/${user.mar_user_id}`}
                className="btn btn-success"
              >
                <i className="fa fa-edit"></i>
              </Link>
            </span>
            <span className="pr-2">
              <Link
                to={`/user/manage/marketer/list-users-are-registered-by-marketer/${user.mar_user_id}`}
                className="btn btn-info"
              >
                <i className="fa fa-user nav-icon"></i>
              </Link>
            </span>
          </td>
        </tr>
      );
    });
  };

  return (
    <>
      <Sidebar openItem="users" activeItem="all-marketer" />

      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1 bg-warning">همه کاربران بازاریاب</h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <div className="pb-2">
                <Link class="btn btn-success" to="/user/marketer/add">
                  <span class="pl-2">
                    <i class="fa fa-plus"></i>
                  </span>
                  <span>اضافه کردن بازاریاب</span>
                </Link>
              </div>

              <div className="table-responsive">
                <table className="table table-hilite tbl-td-white-space">
                  <thead>
                    <tr>
                      <td>#</td>
                      <td>شماره کاربری</td>
                      <td>نام</td>
                      <td>نام خانوادگی</td>
                      <td>شماره موبایل</td>
                      <td>شناسه بازاریابی</td>
                      <td>وضعیت</td>
                      <td>تاریخ ثبت نام</td>
                      <td>عملیات</td>
                    </tr>
                  </thead>
                  <tbody>{generateUsers()}</tbody>
                </table>
              </div>
              {countPage > 1 ? generatePagination() : <></>}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
